import type { DiffItemRef } from '~/api/types'
import { Card } from '~/components/ui/card'
import { cn } from '~/lib/utils'
import { addedKey } from './constants'
import { EmptyTab, ItemIdentity, SelectAllBar } from './DiffParts'

// ── 추가 ──────────────────────────────────────────────────────────────────────

export function AddedList({
    items,
    selected,
    onToggle,
    onToggleAll,
}: {
    items: DiffItemRef[]
    selected: Set<number>
    onToggle: (i: number) => void
    onToggleAll: (checked: boolean) => void
}) {
    if (items.length === 0) {
        return <EmptyTab text='추가된 항목이 없어요.' />
    }
    return (
        <div className='space-y-2'>
            <SelectAllBar
                label='추가 항목 전체 선택'
                total={items.length}
                selected={selected.size}
                onToggleAll={onToggleAll}
            />
            {items.map((item, i) => {
                const checked = selected.has(i)
                return (
                    <Card
                        key={addedKey(i)}
                        className={cn(
                            'flex items-center gap-3 border-l-4 p-3',
                            checked ? 'border-primary' : 'border-success/40'
                        )}>
                        <input
                            type='checkbox'
                            className='size-4 accent-[var(--primary)]'
                            checked={checked}
                            onChange={() => onToggle(i)}
                        />
                        <div className='min-w-0 flex-1'>
                            <ItemIdentity item={item} />
                        </div>
                    </Card>
                )
            })}
        </div>
    )
}
